<template>
  <div class="page-content">
    <div class="page-main-content">
      <div class="container-fluid">
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in data"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
              :to="`/admin/visualizers/${item.id}/edit`"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <div>
                    {{ item.first_name + " " + item.last_name }}
                  </div>
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">{{
                  item.user_role
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-subtitle class="text-caption">
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
        <div class="row">
          <bx-box
            :title="
              totalVisualizers +
                ' ' +
                $t('lang.admin.list_of_visualizer_user_locations')
            "
            color="white"
            no-padding
            :loading="shouldLoading"
            class="col-12"
          >
            <template v-slot:default>
              <skeleton-table :columns="6" v-if="shouldLoading" />

              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                :total="totalVisualizers"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered>{{
                    props.row.first_name
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.last_name
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.email
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.editor
                      ? $t("lang.admin.label_editor")
                      : $t("lang.admin.label_visualizer")
                  }}</bx-table-column>
                  <bx-table-column centered>
                    <router-link
                      :to="`/admin/visualizers/${props.row.id}/edit`"
                      class="bx-link bx-link-bold"
                      >Edit</router-link
                    >
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DevicesList",
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      totalVisualizers: 0,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1
    };
  },
  beforeMount() {
    this.$store.dispatch("setSideMenu", "admin_menu");
  },
  mounted() {
    this.getData();
  },
  methods: {
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      let visualizer = await this.$api.visualizer.list({
        offset: (this.page - 1) * this.itemsPerPage,
        limit: this.itemsPerPage
      });
      this.data = visualizer.results;
      this.totalVisualizers = visualizer.count;
      this.columns = [
        {
          field: "first_name",
          label: this.$t("lang.admin.label_first_name"),
          centered: true
        },
        {
          field: "last_name",
          label: this.$t("lang.admin.label_last_name"),
          centered: true
        },
        {
          field: "email",
          label: this.$t("lang.admin.label_email"),
          centered: true
        },
        {
          field: "role",
          label: this.$t("lang.admin.label_role"),
          centered: true
        },
        {
          field: "",
          label: this.$t("lang.admin.label_action"),
          centered: true
        }
      ];
      this.shouldLoading = false;
    }
  }
};
</script>

<style></style>
